var rtlStyles = {"rtl":"RGdHt","ltr":"HbWqo"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-5e8509b9.js.map
